
















































































































import { Component, Vue, Ref, Prop, Inject, Mixins } from 'vue-property-decorator';
import common from './formPublic/common';
@Component({
	name: 'detailRecord'
})
export default class DetailRecord extends Mixins(common) {
	@Prop() public worksheetId!: string;
	@Prop({ default: () => [] }) public hideRow!: string;
	@Prop({ default: false }) public isAdmin!: boolean;
	@Prop({ default: () => [] }) public sheetFieldList!: any[];
	@Prop({ default: '' }) public titleBusinessId!: string;
	@Prop({ default: null }) public bidirectionalAssociation!: any; // 双向关联
	@Prop({ default: false }) public processId!: string; // 流程id
	@Prop({ default: () => ({}) }) public priorityAuthorityMap!: any; // 审批权限或锁定权限
}
